import _Object$keys from '@babel/runtime-corejs3/core-js/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptors';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import * as React from 'react';
import { useRef, useState, useCallback, useEffect } from 'react';
import { api, Supports } from '@bilibili-maoer/web-utils';
import classNames from 'classnames';
import usePrevious from 'react-use/esm/usePrevious';
import { prependPrefix } from '../../utils/style.js';
import { addToCache, isImageInCache } from './cache.js';
import createIntersectionObserver from './intersection-observer.js';

var _excluded = ["src", "alt", "title", "width", "height", "defaultImage", "className", "visibilityThreshold", "visibilityObserverFactory"],
    _excluded2 = ["className", "preserveLoadingStyle"],
    _excluded3 = ["className", "preserveLoadingStyle"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
var DEFAULT_CAT_IMAGE = "".concat(api.MISSEVAN_CDN_PREFIX_URL, "/assets/images/index/lazy_load.png");
Supports.init();
var LazyImage = function LazyImage(_ref) {
  var _classNames;

  var rawSrc = _ref.src,
      alt = _ref.alt,
      title = _ref.title,
      width = _ref.width,
      height = _ref.height,
      rawDefaultImage = _ref.defaultImage,
      className = _ref.className,
      _ref$visibilityThresh = _ref.visibilityThreshold,
      visibilityThreshold = _ref$visibilityThresh === void 0 ? 0 : _ref$visibilityThresh,
      _ref$visibilityObserv = _ref.visibilityObserverFactory,
      visibilityObserverFactory = _ref$visibilityObserv === void 0 ? createIntersectionObserver : _ref$visibilityObserv,
      props = _objectWithoutProperties(_ref, _excluded);

  var containerRef = useRef(null);

  var _useState = useState('unready'),
      _useState2 = _slicedToArray(_useState, 2),
      status = _useState2[0],
      setStatus = _useState2[1];

  var src = rawSrc ? api.processImageUrl(rawSrc) : '';

  var resolveDefaultImage = function resolveDefaultImage() {
    // 如果传入 defaultImage 为 null，那么不适用默认的 defaultImage
    if (rawDefaultImage === null) {
      return undefined;
    }

    if (rawDefaultImage === undefined) {
      return DEFAULT_CAT_IMAGE;
    }

    return api.processImageUrl(rawDefaultImage);
  };

  var defaultImage = resolveDefaultImage();
  var currSrc = useRef(src);
  var prevSrc = usePrevious(src);
  currSrc.current = src;
  var startLoad = useCallback(function () {
    setStatus('loading');

    if (!src) {
      return;
    }

    var pendingImage = src;
    var img = new Image();
    img.src = pendingImage;

    img.onload = function () {
      if (pendingImage === currSrc.current) {
        setStatus('loaded');
      }

      addToCache(src);
      img.onload = null;
    };
  }, [src]);
  useEffect(function () {
    if (src === prevSrc && status !== 'unready') {
      return undefined;
    }

    if (isImageInCache(src)) {
      setStatus('loaded');
      return undefined;
    }

    if (src !== prevSrc) {
      setStatus('unready');
    }

    if (!containerRef.current) {
      return undefined;
    }

    var _containerRef$current = containerRef.current.getBoundingClientRect(),
        top = _containerRef$current.top,
        bottom = _containerRef$current.bottom;

    if (top - visibilityThreshold <= window.innerHeight && bottom + visibilityThreshold >= 0) {
      startLoad();
      return undefined;
    }

    var unobserve = visibilityObserverFactory({
      threshold: visibilityThreshold
    }).observe(containerRef.current, {
      onVisible: function onVisible() {
        unobserve();
        startLoad();
      }
    });
    return unobserve;
  }, [visibilityThreshold, src, status, prevSrc, visibilityObserverFactory, startLoad]);
  useEffect(function () {
    if (!rawSrc) {
      console.error('src of a LazyImage is given a falsy value. It should be given a valid src rather than falsy.');
    }
  }, [rawSrc]);
  var realImage = {
    unready: defaultImage,
    loading: defaultImage,
    loaded: src
  }[status];
  var isDivMode = props.divComponent || props.children;
  var realClassName = classNames(className, "lazy-".concat(status), prependPrefix('lazy-image'), (_classNames = {}, _defineProperty(_classNames, prependPrefix('lazy-image-div'), isDivMode), _defineProperty(_classNames, prependPrefix('lazy-image-img'), !isDivMode), _classNames));

  if (isDivMode || status === 'unready' || status === 'loading') {
    return /*#__PURE__*/React.createElement("div", {
      ref: containerRef,
      className: classNames(realClassName),
      title: title,
      style: _objectSpread({
        width: width,
        height: height
      }, {
        backgroundImage: realImage ? "url(\"".concat(realImage, "\")") : undefined
      })
    }, props.children);
  }

  return /*#__PURE__*/React.createElement("img", {
    ref: containerRef,
    className: realClassName,
    alt: alt,
    title: title,
    src: realImage,
    style: {
      width: width,
      height: height
    }
  });
};
var CircleLazyImage = function CircleLazyImage(_ref2) {
  var className = _ref2.className,
      _ref2$preserveLoading = _ref2.preserveLoadingStyle,
      preserveLoadingStyle = _ref2$preserveLoading === void 0 ? true : _ref2$preserveLoading,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React.createElement(LazyImage, _objectSpread({
    className: classNames(className, prependPrefix('circle'), {
      'preserve-loading-style': preserveLoadingStyle
    }),
    defaultImage: null
  }, rest));
};
var SquareLazyImage = function SquareLazyImage(_ref3) {
  var className = _ref3.className,
      _ref3$preserveLoading = _ref3.preserveLoadingStyle,
      preserveLoadingStyle = _ref3$preserveLoading === void 0 ? true : _ref3$preserveLoading,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/React.createElement(LazyImage, _objectSpread({
    className: classNames(className, prependPrefix('square'), {
      'preserve-loading-style': preserveLoadingStyle
    }),
    defaultImage: null
  }, rest));
};

export { CircleLazyImage, LazyImage, SquareLazyImage };
